import { COMPANY } from "#app/config/company.js";

export function getOrganizationSchema(baseUrl) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Schnerp",
    legalName: COMPANY.legalName,
    url: baseUrl,
    address: {
      "@type": "PostalAddress",
      streetAddress: COMPANY.streetAddress,
      addressLocality: COMPANY.locality,
      addressRegion: COMPANY.region,
      postalCode: COMPANY.postalCode,
      addressCountry: COMPANY.countryCode,
    },
    logo: `${baseUrl}/logo/schnerp_symbol@4x.png`,
    contactPoint: {
      "@type": "ContactPoint",
      email: "help@schnerp.com",
      contactType: "customer support",
    },
  };
}

export function getFaqPageSchema(questions) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map(({ question, answer }) => ({
      "@type": "Question",
      name: question,
      acceptedAnswer: {
        "@type": "Answer",
        text: answer,
      },
    })),
  };
}

// `url` is the post's canonical address and `baseUrl` the site origin; the
// image is resolved against it so search engines get an absolute URL.
export function getBlogPostingSchema({
  title,
  excerpt,
  publishedAt,
  updatedAt,
  author,
  url,
  image,
  baseUrl,
}) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: title,
    description: excerpt,
    datePublished: publishedAt,
    dateModified: updatedAt || publishedAt,
    url,
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
    ...(image && { image: new URL(image, baseUrl).href }),
    author: {
      "@type": "Person",
      name: author?.name || "Schnerp Team",
      ...(author?.title && { jobTitle: author.title }),
      url: `${baseUrl}/about`,
    },
    publisher: {
      "@type": "Organization",
      name: "Schnerp",
      url: baseUrl,
      logo: {
        "@type": "ImageObject",
        url: `${baseUrl}/logo/schnerp_symbol@4x.png`,
      },
    },
  };
}
